export default __webpack_public_path__ + "img/c132e6d53ccadca266017ef9b1c8b635.svg";